import template from './_payment-gateway.pug'

export default Vue.extend({
  template: template(),
  props: {
    text: {
      type: String,
      default: undefined
    },
    rechargeData: {
      type: Object,
      default() {
        return {
          amount: undefined,
          buy_order: undefined,
          media_code: undefined,
          media_type: undefined,
          pay_url: undefined,
          retries: undefined,
          state: undefined,
          token: undefined,
          trans_date: undefined,
          is_nominal: undefined,
          id: undefined,
          administrative_area_name: undefined,
          response_code: undefined
        }
      }
    },
    formDataReady: {
      type: Boolean,
      required: true
    },
    scriptAttrs: {
      type: Object,
      required: true
    },
    formAttrs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      expectedErrors: [
        '100-100-101',
        '800-100-151',
        '800-100-152',
        '800-100-153',
        '800-100-156',
        '800-100-157',
        '800-100-159',
        '800-100-160',
        '800-100-161',
        '800-100-162',
        '800-100-163',
        '800-100-165',
        '800-100-172',
        '800-100-176',
        '800-100-192',
        '800-100-202',
        '800-100-203'
      ]
    }
  },
  computed: {
    getLoadingStates() {
      const states = ['resolved', 'completed', 'pending', 'admited', 'waiting_confirmation']

      return _.includes(states, this.rechargeData.state)
    },
    getStateTitle() {
      return this.$t(`recharge.paymentGateway.states.${this.rechargeData.state}.title`)
    },
    getStateDescription() {
      if (this.rechargeData && this.rechargeData.response_code) {
        const responseCode = this.rechargeData.response_code.replaceAll('.', '-')

        if (_.includes(this.expectedErrors, responseCode)) {
          return this.$t(`recharge.paymentGateway.states.expectedErrors.${responseCode}`)
        }
      }

      return this.$t(`recharge.paymentGateway.states.${this.rechargeData.state}.description`)
    },
    showPaymentForm() {
      return this.formDataReady && this.rechargeData.state === 'admited'
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    retry() {
      const formData = {
        media_code: this.rechargeData.media_code,
        media_type: this.rechargeData.media_type,
        email: this.rechargeData.email,
        is_nominal_recharge: this.rechargeData.is_nominal
      }

      this.$emit('go-to-step-zero-with-value', formData)
    }
  }
})
